import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';

const UsersPage = () => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const [formData, setFormData] = useState({
    username: '',
    slug: '',
    email: '',
    password: '',
    confirm_password: '',
    first_name: '',
    last_name: '',
    phone: '',
    role: 'user',
    active: 1
  });

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Tarayıcı title'ını ayarla
    document.title = 'FBAJANS WhatsApp Business - Kullanıcı Yönetimi';
    
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      console.log('Kullanıcılar yükleniyor...');
      const response = await fetch('/api/admin/users');
      console.log('Response status:', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('API Response:', data);
        
        if (data.success) {
          setUsers(data.data || []);
          console.log('Kullanıcılar yüklendi:', data.data?.length || 0);
        } else {
          console.error('API hatası:', data.message);
          alert('API Hatası: ' + (data.message || 'Bilinmeyen hata'));
        }
      } else {
        console.error('HTTP Hatası:', response.status);
        alert('HTTP Hatası: ' + response.status);
      }
    } catch (error) {
      console.error('Kullanıcılar yüklenirken hata:', error);
      alert('Bağlantı Hatası: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!editingUser && formData.password !== formData.confirm_password) {
      alert('Şifreler eşleşmiyor');
      return;
    }

    try {
      const userData = {
        username: formData.username,
        slug: formData.slug,
        email: formData.email,
        first_name: formData.first_name,
        last_name: formData.last_name,
        phone: formData.phone,
        role: formData.role,
        active: formData.active
      };

      if (!editingUser) {
        userData.password = formData.password;
      }
      
      if (editingUser) {
        userData.id = editingUser.id;
        await fetch('/api/auth/edit_user.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(userData)
        });
      } else {
        await fetch('/api/auth/add_user.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(userData)
        });
      }
      
      resetForm();
      loadUsers();
      alert(editingUser ? 'Kullanıcı güncellendi!' : 'Kullanıcı eklendi!');
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      username: user.username || '',
      slug: user.slug || '',
      email: user.email || '',
      password: '',
      confirm_password: '',
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      phone: user.phone || '',
      role: user.role || 'user',
      active: user.active ? 1 : 0
    });
    setShowForm(true);
  };

  const handleDelete = async (user) => {
    if (!window.confirm(`${user.username} kullanıcısını silmek istediğinize emin misiniz?`)) return;
    
    try {
      await fetch('/api/auth/delete_user.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: user.id })
      });
      loadUsers();
      alert('Kullanıcı silindi!');
    } catch (error) {
      alert('Silme hatası: ' + (error.response?.data?.error || error.message));
    }
  };

  const resetForm = () => {
    setFormData({
      username: '',
      slug: '',
      email: '',
      password: '',
      confirm_password: '',
      first_name: '',
      last_name: '',
      phone: '',
      role: 'user',
      active: 1
    });
    setEditingUser(null);
    setShowForm(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const refreshUsers = async () => {
    setLoading(true);
    try {
      await loadUsers();
      
      const notification = document.createElement('div');
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: linear-gradient(135deg, #28a745, #20c997);
        color: white;
        padding: 15px 20px;
        border-radius: 10px;
        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
        z-index: 1000;
        font-weight: 600;
        animation: slideIn 0.3s ease-out;
      `;
      notification.textContent = 'Kullanıcılar yenilendi!';
      document.body.appendChild(notification);
      
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 3000);
    } catch (error) {
      console.error('Yenileme hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  // Mobile User Card Component
  const UserCard = ({ user }) => (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '16px',
      marginBottom: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      border: '1px solid #e0e0e0'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div style={{ flex: 1 }}>
          <h3 style={{ 
            margin: '0 0 4px 0', 
            fontSize: '16px', 
            fontWeight: 'bold', 
            color: '#333' 
          }}>
            {user.first_name} {user.last_name}
          </h3>
          <div style={{ 
            fontSize: '12px', 
            color: '#666', 
            background: '#f5f5f5', 
            padding: '2px 8px', 
            borderRadius: '4px', 
            display: 'inline-block',
            marginBottom: '4px'
          }}>
            @{user.username}
          </div>
          <div style={{ 
            fontSize: '11px', 
            color: '#888',
            marginBottom: '8px'
          }}>
            {user.email}
          </div>
        </div>
        <div style={{
          background: user.active ? '#28a745' : '#dc3545',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '11px',
          fontWeight: 'bold'
        }}>
          {user.active ? 'Aktif' : 'Pasif'}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '12px' }}>
        <div>
          <div style={{ fontSize: '11px', color: '#888' }}>Rol</div>
          <div style={{ 
            fontSize: '12px', 
            background: user.role === 'admin' ? '#007bff' : '#6c757d',
            color: 'white',
            padding: '2px 6px',
            borderRadius: '8px',
            display: 'inline-block'
          }}>
            {user.role === 'admin' ? '👑 Admin' : '👤 Kullanıcı'}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '11px', color: '#888' }}>Telefon</div>
          <div style={{ fontSize: '12px', color: '#333' }}>
            {user.phone || 'Belirtilmemiş'}
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '12px' }}>
        <div style={{ fontSize: '11px', color: '#888' }}>Slug</div>
        <div style={{ 
          fontSize: '12px', 
          color: '#666', 
          background: '#e9ecef', 
          padding: '2px 8px', 
          borderRadius: '4px', 
          display: 'inline-block',
          fontFamily: 'monospace'
        }}>
          {user.slug}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={() => handleEdit(user)}
          style={{
            flex: 1,
            background: '#007bff',
            color: 'white',
            border: 'none',
            padding: '8px 12px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          <i className="fas fa-edit" style={{ marginRight: '8px' }}></i>
          Düzenle
        </button>
        <button
          onClick={() => handleDelete(user)}
          style={{
            flex: 1,
            background: '#dc3545',
            color: 'white',
            border: 'none',
            padding: '8px 12px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          <i className="fas fa-trash" style={{ marginRight: '8px' }}></i>
          Sil
        </button>
      </div>
    </div>
  );

  if (loading) return <div style={{ textAlign: 'center', padding: '20px' }}>Yükleniyor...</div>;

  return (
    <AdminLayout>
      <div style={{ padding: isMobile ? '15px' : '30px' }}>
        {/* Standart Header */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '30px',
          marginBottom: '30px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '20px' : '0'
          }}>
            <div>
              <h1 style={{ 
                margin: '0 0 5px', 
                fontSize: isMobile ? '24px' : '32px', 
                fontWeight: '700',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                FBAJANS WhatsApp Business
              </h1>
              <p style={{ 
                margin: '0 0 5px', 
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '500',
                color: '#555'
              }}>
                <i className="fas fa-users" style={{ marginRight: '8px' }}></i>
                Kullanıcı Yönetimi
              </p>
              <p style={{ 
                margin: '5px 0 0 0', 
                fontSize: isMobile ? '13px' : '14px',
                color: '#999'
              }}>
                {isMobile ? `Toplam ${users.length} kullanıcı` : 'Sistem kullanıcılarını ekleyin, düzenleyin ve yönetin'}
              </p>
            </div>
            <div style={{
              display: 'flex',
              gap: '15px',
              flexWrap: 'wrap',
              justifyContent: isMobile ? 'center' : 'flex-end'
            }}>
              <button
                onClick={refreshUsers}
                disabled={loading}
                style={{
                  padding: '12px 20px',
                  background: '#f8f9fa',
                  border: '1px solid #e2e8f0',
                  borderRadius: '10px',
                  color: '#333',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s',
                  opacity: loading ? 0.6 : 1
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.target.style.background = '#e9ecef';
                    e.target.style.transform = 'translateY(-2px)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loading) {
                    e.target.style.background = '#f8f9fa';
                    e.target.style.transform = 'translateY(0)';
                  }
                }}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                    Yenileniyor...
                  </>
                ) : (
                  <>
                    <i className="fas fa-sync-alt" style={{ marginRight: '8px' }}></i>
                    Durumları Yenile
                  </>
                )}
              </button>
              <button
                onClick={() => setShowForm(true)}
                style={{
                  padding: '12px 20px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 5px 15px rgba(102, 126, 234, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <i className="fas fa-plus" style={{ marginRight: '8px' }}></i>
                Yeni Kullanıcı
              </button>
            </div>
          </div>
        </div>

        {/* Kullanıcı Sayısı Bilgisi - Sadece Desktop */}
        {!isMobile && (
          <div style={{
            background: '#fff', 
            padding: '15px 20px', 
            borderRadius: '8px', 
            marginBottom: '20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            border: '1px solid #dee2e6'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}>
                <i className="fas fa-chart-bar" style={{ marginRight: '8px' }}></i>
                Toplam Kullanıcı: <strong>{users.length}</strong>
              </span>
              <span style={{ fontSize: '14px', color: '#6c757d' }}>
                Son güncelleme: {new Date().toLocaleString('tr-TR')}
              </span>
            </div>
          </div>
        )}

        {/* Users List */}
        {isMobile ? (
          // Mobile Card View
          <div>
            {users.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '40px 20px',
                color: '#666',
                background: 'white',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <i className="fas fa-users" style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}></i>
                <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>Henüz kullanıcı bulunmuyor</div>
                <div style={{ fontSize: '14px' }}>İlk kullanıcıyı eklemek için yukarıdaki butona tıklayın</div>
              </div>
            ) : (
              users.map(user => (
                <UserCard key={user.id} user={user} />
              ))
            )}
          </div>
        ) : (
          // Desktop Table View
          users.length > 0 ? (
            <div style={{ marginTop: 20 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: 'white', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                <thead style={{ background: '#007bff', color: 'white' }}>
                  <tr>
                    <th style={{ padding: 12, textAlign: 'center', fontSize: 14 }}>ID</th>
                    <th style={{ padding: 12, textAlign: 'left', fontSize: 14 }}>Kullanıcı</th>
                    <th style={{ padding: 12, textAlign: 'center', fontSize: 14 }}>Telefon</th>
                    <th style={{ padding: 12, textAlign: 'center', fontSize: 14 }}>Rol</th>
                    <th style={{ padding: 12, textAlign: 'center', fontSize: 14 }}>Firma Slug</th>
                    <th style={{ padding: 12, textAlign: 'center', fontSize: 14 }}>Durum</th>
                    <th style={{ padding: 12, textAlign: 'center', fontSize: 14 }}>İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map(user => (
                    <tr key={user.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: 12, fontSize: 14, textAlign: 'center' }}>{user.id}</td>
                      <td style={{ padding: 12, fontSize: 14 }}>
                        <div style={{ fontWeight: '600', color: '#007bff' }}>{user.username}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          {user.first_name} {user.last_name}
                        </div>
                        <div style={{ fontSize: '12px', color: '#666' }}>{user.email}</div>
                      </td>
                      <td style={{ padding: 12, fontSize: 14, textAlign: 'center' }}>
                        {user.phone || '-'}
                      </td>
                      <td style={{ padding: 12, fontSize: 14, textAlign: 'center' }}>
                        <span style={{
                          padding: '4px 8px',
                          borderRadius: 4,
                          fontSize: 12,
                          backgroundColor: user.role === 'admin' ? '#fff3cd' : '#e3f2fd',
                          color: user.role === 'admin' ? '#856404' : '#1976d2',
                          fontWeight: 'bold'
                        }}>
                          {user.role === 'admin' ? '👑 Admin' : '👤 Kullanıcı'}
                        </span>
                      </td>
                      <td style={{ padding: 12, fontSize: 14, textAlign: 'center', fontWeight: '600', color: '#007bff' }}>
                        {user.slug}
                      </td>
                      <td style={{ padding: 12, fontSize: 14, textAlign: 'center' }}>
                        <span style={{
                          padding: '4px 8px',
                          borderRadius: 4,
                          fontSize: 12,
                          backgroundColor: user.active ? '#d4edda' : '#f8d7da',
                          color: user.active ? '#155724' : '#721c24',
                          fontWeight: 'bold'
                        }}>
                          {user.active ? '🟢 Aktif' : '🔴 Pasif'}
                        </span>
                      </td>
                      <td style={{ padding: 12, fontSize: 14, textAlign: 'center' }}>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                          <button
                            onClick={() => handleEdit(user)}
                            style={{
                              padding: '6px 12px',
                              background: 'linear-gradient(135deg, #007bff, #0056b3)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '500'
                            }}
                          >
                            <i className="fas fa-edit" style={{ marginRight: '8px' }}></i>
          Düzenle
                          </button>
                          <button
                            onClick={() => handleDelete(user)}
                            style={{
                              padding: '6px 12px',
                              background: 'linear-gradient(135deg, #dc3545, #c82333)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '500'
                            }}
                          >
                            <i className="fas fa-trash" style={{ marginRight: '8px' }}></i>
          Sil
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '60px 20px', 
              background: '#fff',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              border: '1px solid #dee2e6'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '20px', opacity: 0.5 }}>👤</div>
              <h3 style={{ color: '#6c757d', marginBottom: '10px' }}>Henüz kullanıcı eklenmemiş</h3>
              <p style={{ color: '#6c757d', marginBottom: '20px' }}>
                Yeni kullanıcı eklemek için yukarıdaki "➕ Yeni Kullanıcı Ekle" butonunu kullanın.
              </p>
            </div>
          )
        )}

        {/* Form Modal */}
        {showForm && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: isMobile ? '20px' : '0'
          }}>
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: isMobile ? '20px' : '30px',
              width: isMobile ? '100%' : '600px',
              maxWidth: '100%',
              maxHeight: isMobile ? '90vh' : '80vh',
              overflow: 'auto'
            }}>
              <h2 style={{ 
                margin: '0 0 20px 0', 
                fontSize: isMobile ? '18px' : '20px',
                color: '#333'
              }}>
                {editingUser ? (
                  <>
                    <i className="fas fa-edit" style={{ marginRight: '8px' }}></i>
                    Kullanıcı Düzenle
                  </>
                ) : (
                  <>
                    <i className="fas fa-plus" style={{ marginRight: '8px' }}></i>
                    Yeni Kullanıcı Ekle
                  </>
                )}
              </h2>

              <form onSubmit={handleSubmit}>
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(180px, 1fr))', 
                  gap: '15px',
                  marginBottom: '20px'
                }}>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '5px', 
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333'
                    }}>
                      Kullanıcı Adı *
                    </label>
                    <input
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleInputChange}
                      required
                      placeholder="kullanici_adi"
                      style={{ 
                        width: '100%', 
                        padding: isMobile ? '12px' : '8px', 
                        marginTop: 5, 
                        boxSizing: 'border-box', 
                        fontSize: '14px',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '5px', 
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333'
                    }}>
                      Firma Slug *
                    </label>
                    <input
                      type="text"
                      name="slug"
                      value={formData.slug}
                      onChange={handleInputChange}
                      required
                      placeholder="fbajans"
                      style={{ 
                        width: '100%', 
                        padding: isMobile ? '12px' : '8px', 
                        marginTop: 5, 
                        boxSizing: 'border-box', 
                        fontSize: '14px',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '5px', 
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333'
                    }}>
                      E-posta
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="ornek@email.com"
                      style={{ 
                        width: '100%', 
                        padding: isMobile ? '12px' : '8px', 
                        marginTop: 5, 
                        boxSizing: 'border-box', 
                        fontSize: '14px',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '5px', 
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333'
                    }}>
                      Ad
                    </label>
                    <input
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                      placeholder="Ad"
                      style={{ 
                        width: '100%', 
                        padding: isMobile ? '12px' : '8px', 
                        marginTop: 5, 
                        boxSizing: 'border-box', 
                        fontSize: '14px',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '5px', 
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333'
                    }}>
                      Soyad
                    </label>
                    <input
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                      placeholder="Soyad"
                      style={{ 
                        width: '100%', 
                        padding: isMobile ? '12px' : '8px', 
                        marginTop: 5, 
                        boxSizing: 'border-box', 
                        fontSize: '14px',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '5px', 
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333'
                    }}>
                      Telefon
                    </label>
                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+90 555 123 4567"
                      style={{ 
                        width: '100%', 
                        padding: isMobile ? '12px' : '8px', 
                        marginTop: 5, 
                        boxSizing: 'border-box', 
                        fontSize: '14px',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px'
                      }}
                    />
                  </div>
                </div>

                {!editingUser && (
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(180px, 1fr))', 
                    gap: '15px',
                    marginBottom: '20px'
                  }}>
                    <div>
                      <label style={{ 
                        display: 'block', 
                        marginBottom: '5px', 
                        fontWeight: 'bold',
                        fontSize: '14px',
                        color: '#333'
                      }}>
                        Şifre *
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        required
                        placeholder="Güçlü şifre giriniz"
                        style={{ 
                          width: '100%', 
                          padding: isMobile ? '12px' : '8px', 
                          marginTop: 5, 
                          boxSizing: 'border-box', 
                          fontSize: '14px',
                          border: '2px solid #e0e0e0',
                          borderRadius: '8px'
                        }}
                      />
                    </div>
                    <div>
                      <label style={{ 
                        display: 'block', 
                        marginBottom: '5px', 
                        fontWeight: 'bold',
                        fontSize: '14px',
                        color: '#333'
                      }}>
                        Şifre Tekrar *
                      </label>
                      <input
                        type="password"
                        name="confirm_password"
                        value={formData.confirm_password}
                        onChange={handleInputChange}
                        required
                        placeholder="Şifrenizi tekrar giriniz"
                        style={{ 
                          width: '100%', 
                          padding: isMobile ? '12px' : '8px', 
                          marginTop: 5, 
                          boxSizing: 'border-box', 
                          fontSize: '14px',
                          border: '2px solid #e0e0e0',
                          borderRadius: '8px'
                        }}
                      />
                    </div>
                  </div>
                )}

                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(180px, 1fr))', 
                  gap: '15px',
                  marginBottom: '25px'
                }}>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '5px', 
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333'
                    }}>
                      Rol
                    </label>
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleInputChange}
                      style={{ 
                        width: '100%', 
                        padding: isMobile ? '12px' : '8px', 
                        marginTop: 5, 
                        boxSizing: 'border-box', 
                        fontSize: '14px',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px',
                        background: 'white'
                      }}
                    >
                      <option value="user">👤 Kullanıcı</option>
                      <option value="admin">👑 Admin</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '5px', 
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333'
                    }}>
                      Durum
                    </label>
                    <select
                      name="active"
                      value={formData.active}
                      onChange={handleInputChange}
                      style={{ 
                        width: '100%', 
                        padding: isMobile ? '12px' : '8px', 
                        marginTop: 5, 
                        boxSizing: 'border-box', 
                        fontSize: '14px',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px',
                        background: 'white'
                      }}
                    >
                      <option value={1}>🟢 Aktif</option>
                      <option value={0}>🔴 Pasif</option>
                    </select>
                  </div>
                </div>

                <div style={{ 
                  marginTop: 20, 
                  display: 'flex', 
                  gap: '10px',
                  flexDirection: isMobile ? 'column' : 'row'
                }}>
                  <button
                    type="submit"
                    style={{
                      flex: 1,
                      padding: isMobile ? '14px 20px' : '10px 20px',
                      background: 'linear-gradient(135deg, #28a745, #20c997)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    <i className="fas fa-save" style={{ marginRight: '8px' }}></i>
                    {editingUser ? 'Güncelle' : 'Kaydet'}
                  </button>
                  <button
                    type="button"
                    onClick={resetForm}
                    style={{
                      flex: 1,
                      padding: isMobile ? '14px 20px' : '10px 20px',
                      background: 'linear-gradient(135deg, #6c757d, #5a6268)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    <i className="fas fa-times" style={{ marginRight: '8px' }}></i>
                    İptal
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default UsersPage; 